export default __webpack_public_path__ + "static/media/login-shape.6cb01c54.svg";